import React from 'react';
import DashboardContent from '../../components/Dashboard';

const DashboardContainer: React.FC = () => {
  // Aqui você pode adicionar lógica de negócio, chamadas de API, etc.
  return <DashboardContent />;
};

export default DashboardContainer;
